import { trackEvent } from 'tracking/tracking';
import type {
  EphemeralNotificationEvent,
  TrackableNotificationConfig,
} from './types';

export type EphemeralNotificationTrackingEvent = EphemeralNotificationEvent & {
  viewCount: number;
};

const ephemeralNotificationTrackingEventNames: Record<
  EphemeralNotificationTrackingEvent['type'],
  string
> = {
  seen: 'EphNotif: seen',
  actionClicked: 'EphNotif: action clicked',
  dismissed: 'EphNotif: dismissed',
  externalLinkClicked: 'EphNotif: external link clicked',
  slideNavigated: 'EphNotif: slide navigated',
};

export const trackEphemeralNotificationEvent = (
  { id, kind, eventProperties }: TrackableNotificationConfig,
  { type, ...metadata }: EphemeralNotificationTrackingEvent
): void => {
  trackEvent(ephemeralNotificationTrackingEventNames[type], {
    ...eventProperties,
    notificationId: id,
    kind,
    ...metadata,
  });
};
